// utils/dynamicFavicon.js

let currentColor1 = null
let currentColor2 = null
let animationFrame = null

// Генерація SVG із двома кольорами
function generateFaviconSvg(color1 = '#778a99', color2 = '#778a99') {
	return `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" width="32" height="32">
  <g transform="scale(-1,1) translate(-90,0)">
    <path d="M48.7 68.06c-.81 0-1.48-.65-1.5-1.47-.02-.83.64-1.51 1.47-1.53 12.71-.25 23.05-10.8 23.05-23.52 0-12.97-10.55-23.52-23.52-23.52-12.77 0-23.32 10.38-23.52 23.14-.01.83-.7 1.47-1.52 1.48-.83-.01-1.49-.7-1.48-1.52.23-14.39 12.12-26.1 26.52-26.1 14.63 0 26.52 11.9 26.52 26.52 0 14.34-11.66 26.24-25.99 26.52h-.01z" fill="${color1}"/>
    <path d="M48.2 83.08c-1.15 0-2.31-.05-3.46-.14-.83-.07-1.44-.79-1.37-1.62.07-.83.79-1.43 1.62-1.37 1.07.09 2.14.13 3.21.13 21.25 0 38.54-17.29 38.54-38.54 0-21.25-17.29-38.54-38.54-38.54s-38.54 17.29-38.54 38.54c0 1.06.04 2.13.13 3.19.07.82-.55 1.55-1.37 1.62-.83.07-1.55-.55-1.62-1.37-.09-1.13-.14-2.29-.14-3.43C6.67 18.63 25.3 0 48.2 0s41.54 18.63 41.54 41.54c0 22.9-18.63 41.54-41.54 41.54z" fill="${color1}"/>
    <path d="M52.85 51.91c-.54 0-1.06-.29-1.33-.8-.39-.73-.1-1.64.63-2.03 2.82-1.48 4.57-4.37 4.57-7.55 0-4.69-3.82-8.51-8.51-8.51-3.27 0-6.2 1.82-7.64 4.76-.36.74-1.27 1.05-2.01.68-.74-.36-1.05-1.26-.68-2.01 1.95-3.97 5.91-6.43 10.33-6.43 6.35 0 11.51 5.17 11.51 11.51 0 4.29-2.37 8.2-6.17 10.2-.24.13-.47.19-.72.19z" fill="${color1}"/>
    <path d="M10.88 90c-.38 0-.77-.15-1.06-.44L.69 80.44c-.28-.28-.44-.66-.44-1.06s.16-.78.44-1.06L16.81 62.2l-8.16-8.16c-.37-.37-.52-.92-.39-1.43.13-.51.52-.92 1.03-1.07l38.48-11.44c.52-.15 1.1-.01 1.48.38.39.39.53.96.38 1.48L38.72 80.97c-.15.51-.56.9-1.07 1.03-.51.13-1.06-.02-1.43-.39l-8.16-8.16L11.94 89.56c-.29.29-.67.44-1.06.44z" fill="${color2}"/>
  </g>
</svg>
	`.trim()
}

function updateFavicon(color1, color2) {
	const svg = generateFaviconSvg(color1, color2)
	const encoded = encodeURIComponent(svg)
	const dataUrl = `data:image/svg+xml,${encoded}`

	let link = document.querySelector("link[rel='icon']")
	if (!link) {
		link = document.createElement('link')
		link.rel = 'icon'
		document.head.appendChild(link)
	}
	link.type = 'image/svg+xml'
	link.href = dataUrl
}

function interpolateColor(colorA, colorB, t) {
	const c1 = parseInt(colorA.slice(1), 16)
	const c2 = parseInt(colorB.slice(1), 16)

	const r = Math.round(((c2 >> 16) & 0xff) * t + ((c1 >> 16) & 0xff) * (1 - t))
	const g = Math.round(((c2 >> 8) & 0xff) * t + ((c1 >> 8) & 0xff) * (1 - t))
	const b = Math.round((c2 & 0xff) * t + (c1 & 0xff) * (1 - t))

	return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
}

function animateFaviconTo(newColor1, newColor2, duration = 1000) {
	if (!currentColor1 || !currentColor2) {
		// ініціалізація
		currentColor1 = newColor1
		currentColor2 = newColor2
		updateFavicon(newColor1, newColor2)
		return
	}

	if (animationFrame) cancelAnimationFrame(animationFrame)

	const startTime = performance.now()

	function step(now) {
		const t = Math.min((now - startTime) / duration, 1)
		const c1 = interpolateColor(currentColor1, newColor1, t)
		const c2 = interpolateColor(currentColor2, newColor2, t)

		updateFavicon(c1, c2)

		if (t < 1) {
			animationFrame = requestAnimationFrame(step)
		} else {
			currentColor1 = newColor1
			currentColor2 = newColor2
		}
	}

	animationFrame = requestAnimationFrame(step)
}

export default function setFavicon(color1, color2) {
	animateFaviconTo(color1, color2)
}